var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIconChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6977 7.57447L14.9697 4.84651V1.69525C14.9697 1.12546 14.508 0.663692 13.9374 0.663692C13.368 0.663692 12.9063 1.12546 12.9063 1.69525V2.78313L10.8751 0.751875C9.87089 -0.251817 8.12486 -0.250037 7.12291 0.753692L0.301991 7.57447C-0.100664 7.97792 -0.100664 8.63073 0.301991 9.03357C0.704826 9.43691 1.35891 9.43691 1.7616 9.03357L8.58187 2.21261C8.80405 1.99159 9.19566 1.99159 9.41668 2.21196L16.2381 9.03357C16.4404 9.23526 16.7041 9.33558 16.9677 9.33558C17.2319 9.33558 17.4961 9.23515 17.6977 9.03357C18.1005 8.63077 18.1005 7.97796 17.6977 7.57447Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35815 4.17003C9.15998 3.97197 8.83911 3.97197 8.64153 4.17003L2.64183 10.1679C2.54711 10.2626 2.49341 10.3919 2.49341 10.5268V14.9015C2.49341 15.928 3.32575 16.7603 4.35226 16.7603H7.32271V12.1601H10.6763V16.7603H13.6468C14.6733 16.7603 15.5056 15.928 15.5056 14.9015V10.5268C15.5056 10.3919 15.4524 10.2626 15.3572 10.1679L9.35815 4.17003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIconChild);
export default __webpack_public_path__ + "static/media/houseIconChild.e9ee5463c31c02d4a1e0a54a7fa6e21e.svg";
export { ForwardRef as ReactComponent };